import { useProductOfferStore } from "@expert/sales-tools";
import { Flex } from "@mantine/core";
import { useCallback, useEffect } from "react";

import { useAnalytics } from "@/analytics";
import { useSessionId } from "@/sdk/sessions/hooks/useSessionId";

import { IntegratedFlow } from "../home-product/components/IntegratedFlow";
import { EnrollFailureScreen } from "../home-product/components/StepSpecific/EnrollFailure";
import { SaleView } from "../home-product/components/StepSpecific/SaleView";
import { EligibilityStatus, SaleProgress } from "../home-product/types";

export function ProductSaleFlow() {
    const { dispatcher } = useAnalytics();
    const sessionId = useSessionId();
    const selectedProduct = useProductOfferStore((state) => state.getSelectedProduct(sessionId));

    useEffect(() => {
        void dispatcher.dispatchAction("PageShown", "sale-tool");
    }, [dispatcher]);

    const { getProductInfo } = useProductOfferStore.getState();

    const handleOnPrimarySaleComplete = useCallback(() => {
        useProductOfferStore.getState().updateSelectedProduct(sessionId, undefined);
    }, [sessionId]);

    return selectedProduct?.saleProgress === SaleProgress.InProgress &&
        selectedProduct.status === EligibilityStatus.Eligible ? (
        <IntegratedFlow product={selectedProduct} />
    ) : (
        <Flex data-testid="product-sale-flow-container" h={"100%"} w={"100%"}>
            {/* Endgame */}
            {selectedProduct?.saleProgress === SaleProgress.Success ||
            selectedProduct?.saleProgress === SaleProgress.Declined ? (
                <SaleView
                    onPrimarySaleComplete={handleOnPrimarySaleComplete}
                    status={selectedProduct.saleProgress}
                    productInfo={getProductInfo(sessionId, selectedProduct.productSku)}
                />
            ) : null}

            {/* Show SaleView when product is not eligible */}
            {selectedProduct &&
            selectedProduct.status !== EligibilityStatus.Eligible &&
            selectedProduct.saleProgress !== SaleProgress.Failure ? (
                <SaleView
                    onPrimarySaleComplete={handleOnPrimarySaleComplete}
                    status={selectedProduct.status}
                    productInfo={getProductInfo(sessionId, selectedProduct.productSku)}
                />
            ) : null}

            {/* Alternate Endgame */}
            {selectedProduct?.saleProgress === SaleProgress.Failure ? (
                <EnrollFailureScreen isProductAsurionBilled={selectedProduct.isProductAsurionBilled} />
            ) : null}
        </Flex>
    );
}
